function convertToReal(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

const CustomShippingInit = (e) => {
    var buttonEl = e.target;
    var parent = buttonEl.closest('.custom-shipping-calculator');
    var zipCode = parent.querySelector('.custom_zip_code').value;
    var country = 'Brazil';
    var province = '';

    if(zipCode.length != 9){
        alert('Digite um CEP válido')
    }else{
        parent.classList.add('loading');
        zipCode = zipCode.replace('-','');
        // valida o cep
        fetch(`//viacep.com.br/ws/${zipCode}/json`)
            .then(response => response.json())
            .then(data => {
                var uf = data.uf.toUpperCase();
                switch (uf) {
                    case "AC" :	province = "Acre";					break;
                    case "AL" :	province = "Alagoas";				break;
                    case "AM" :	province = "Amazonas";				break;
                    case "AP" :	province = "Amapá";				break;
                    case "BA" :	province = "Bahia";				break;
                    case "CE" :	province = "Ceará";				break;
                    case "DF" :	province = "Distrito Federal";		break;
                    case "ES" :	province = "Espírito Santo";		break;
                    case "GO" :	province = "Goiás";				break;
                    case "MA" :	province = "Maranhão";				break;
                    case "MG" :	province = "Minas Gerais";			break;
                    case "MS" :	province = "Mato Grosso do Sul";	break;
                    case "MT" :	province = "Mato Grosso";			break;
                    case "PA" :	province = "Pará";					break;
                    case "PB" :	province = "Paraíba";				break;
                    case "PE" :	province = "Pernambuco";			break;
                    case "PI" :	province = "Piauí";				break;
                    case "PR" :	province = "Paraná";				break;
                    case "RJ" :	province = "Rio de Janeiro";		break;
                    case "RN" :	province = "Rio Grande do Norte";	break;
                    case "RO" :	province = "Rondônia";				break;
                    case "RR" :	province = "Roraima";				break;
                    case "RS" :	province = "Rio Grande do Sul";	break;
                    case "SC" :	province = "Santa Catarina";		break;
                    case "SE" :	province = "Sergipe";				break;
                    case "SP" :	province = "São Paulo";			break;
                    case "TO" :	province = "Tocantíns";			break;
                  }

                if(province !== ''){
                    fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zipCode}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
                        .then(response => response.json())
                        .then(data => {
                            
                            var rates = data.shipping_rates;
                            var ratesContainer = parent.querySelector('.shipping-rates');
                            
                            ratesContainer.innerHTML = rates.length > 1 ? `<p><strong>Existem ${rates.length} tipos de fretes disponíveis.</strong></p>` : `<p><strong>Existe ${rates.length} tipo de frete disponível.</strong></p>`;
                            
                            rates.forEach(function(rate) {
                                var rateElement = document.createElement('li');
                                var days = rate.delivery_days[0]
                                var printDays = days > 0 ? `- ${days} ${days === 1 ? 'dia útil' : 'dias úteis'}` : '';
                                var printPrice = rate.price > 0 ? `${convertToReal(rate.price)}` : 'Grátis'
                                rateElement.innerHTML = `<li>
                                    <strong>${rate.name}</strong>
                                    - ${printPrice}
                                    ${printDays}
                                </li>` 
                                ratesContainer.appendChild(rateElement);
                            });
                            parent.classList.remove('loading');
                        })
                        .catch(error => {
                            console.error('Erro ao calcular frete:', error);
                            parent.classList.remove('loading');
                        });
                }else{
                    alert('Indiponível no momento por favor tente novamente mais tarde!')
                    parent.classList.remove('loading');
                }
            })
            .catch(error => {
                parent.classList.remove('loading');
                alert('Digite um CEP válido')
            });
    }
}

// /cart/shipping_rates.json?shipping_address[zip]=${zipCode}&shipping_address[country]=${country}&shipping_address[province]=${province}